import { useEffect, useState } from "react";
import { ArrowRight, X } from "lucide-react";

const PAD = 10;
const CARD_H = 240;

const measure = (testid) => {
  const el = document.querySelector(`[data-testid="${testid}"]`);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  return { top: r.top - PAD, left: r.left - PAD, width: r.width + PAD * 2, height: r.height + PAD * 2 };
};

export const WelcomeTour = ({ steps, onDone }) => {
  const [i, setI] = useState(0);
  const [rect, setRect] = useState(null);
  const step = steps[i];

  useEffect(() => {
    if (!step) return undefined;
    const el = document.querySelector(`[data-testid="${step.testid}"]`);
    if (!el) { setI((n) => n + 1); return undefined; }
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    const update = () => setRect(measure(step.testid));
    const t = setTimeout(update, 450);
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, { passive: true });
    return () => { clearTimeout(t); window.removeEventListener("resize", update); window.removeEventListener("scroll", update); };
  }, [step]);

  useEffect(() => { if (i >= steps.length) onDone(); }, [i, steps.length, onDone]);

  if (!step || !rect) return null;
  const last = i === steps.length - 1;
  const below = rect.top + rect.height + CARD_H < window.innerHeight;
  const cardTop = below ? rect.top + rect.height + 16 : Math.max(16, rect.top - CARD_H - 16);
  const cardLeft = Math.min(Math.max(16, rect.left), window.innerWidth - 400);

  return (
    <div className="fixed inset-0 z-[90]" data-testid="welcome-tour" data-step={i + 1}>
      <div
        className="absolute border-2 border-[#F59E0B] rounded-sm pointer-events-none transition-all duration-500"
        style={{ top: rect.top, left: rect.left, width: rect.width, height: rect.height, boxShadow: "0 0 0 9999px rgba(0,0,0,0.74), 0 0 40px rgba(245,158,11,0.35)" }}
      />
      <div
        className="absolute w-[min(92vw,384px)] bg-[#FFFFFF] border border-[#F59E0B]/50 p-6 shadow-2xl transition-all duration-500"
        style={{ top: cardTop, left: cardLeft }}
      >
        <div className="flex items-center justify-between mb-3">
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309]" data-testid="welcome-tour-step">
            Step {i + 1} of {steps.length}
          </span>
          <button onClick={onDone} data-testid="welcome-tour-skip" aria-label="Skip tour" className="text-[#78716C] hover:text-[#1C1917] transition-colors">
            <X size={16} />
          </button>
        </div>
        <h4 className="font-display text-2xl md:text-3xl tracking-tight leading-tight mb-2" data-testid="welcome-tour-title">{step.title}</h4>
        <p className="text-[#44403C] text-base leading-relaxed mb-5">{step.body}</p>
        <button onClick={() => setI(i + 1)} data-testid="welcome-tour-next" className="btn-ember text-sm">
          {last ? "Got it — let's begin" : "Next"} {!last && <ArrowRight size={14} />}
        </button>
      </div>
    </div>
  );
};
